// rem等比适配配置文件
// 基准大小
const baseSize = 16
// 设置 rem 函数
let lishirem
let scalea
function setRem () {
  // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
   scalea = document.documentElement.clientWidth / 1920
  if(scalea<0.8){
    scalea=0.8
  }
  // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
  document.documentElement.style.fontSize = baseSize * Math.min(scalea, 2) + 'px'
  if(lishirem ===undefined){
    lishirem = scalea
  }
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem()
 // console.log(localStorage.getItem('isreload'));
  //白名单(window.location.href.indexOf('localhost')=='-1'&& window.location.href.indexOf('120.26.86.15')=='-1')
  if(Math.abs(lishirem - scalea) >0.1 && !localStorage.getItem('isreload')){
    document.location.reload()
  }
  lishirem = scalea
}
export default function sumwidth(item,withs) {
  let bili= withs/1920;
  if(bili<0.8){
    bili = 0.8
  }
  return item * bili
}